import React from "react";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import Progress from "@components/progress/progress";

type PropsType = {
  progress: string | number;
  valueInProgress: number | null;
  courseName: string;
  completedLessonsCount: number;
  lessonsCount: number;
  exercisesCount: number;
  completedExercisesCount: number;
  className?: string;
};

function ItemCourse({
  progress,
  valueInProgress,
  courseName,
  completedLessonsCount,
  lessonsCount,
  className,
  exercisesCount,
  completedExercisesCount,
}: PropsType) {
  const currentLessonInProgressOffset = valueInProgress
    ? (valueInProgress * 100) / completedExercisesCount
    : 0;

  return (
    <div className={classNames([className], "w-full")}>
      <div className='mb-2'>
        <b>{courseName}</b>
        <div className='block text-small-xs'>
          {completedLessonsCount === 0 ? null : (
            <FormattedMessage
              id='lesson-from'
              values={{
                lessonsOrder: completedLessonsCount,
                lessonsLength: lessonsCount,
              }}
            />
          )}
        </div>
      </div>
      <Progress
        widthProgress='w-full'
        colorProgressValue='bg-brand-primary dark:bg-brand-dark-primary'
        progress={progress}
        progressActive={currentLessonInProgressOffset}
      />
    </div>
  );
}

export default ItemCourse;
